import {
    default as actions,
    ADD_FEEDBACK,
    CACHE_FEEDBACK
} from './action';
import Stroage from '../../services/api/store';
import CONSTANT from '../../constant';

const cacheData = Stroage.get(CONSTANT.FEEDBACK_CACHE_KEY) || {
    profession: '',
    description: '',
    contact: '',
    call: '',
    attachment: ''
};

const defaultState = {
    cacheData,
    status: null
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case CACHE_FEEDBACK:
        case ADD_FEEDBACK:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};